export const emptyCallFlowObject = {
  id: "",
  displayName: "",
  timeZone: "Europe/Paris",
  language: "en-US",
  dataLocation: "Europe",
  scope: "default",
  region: "EU",
  isTPE: false,

  greeting: {
    emergencyMessage: {
      enabled: false,
      type: "text2speech",
      language: "en-US",
      text: "",
      audioFileUrl:
        "https://callcenterconf.blob.core.windows.net/heedifymedia/defaultGreeting/Default_Greeting.wav",
    },
    welcomeMessage: {
      enabled: true,
      type: "text2speech",
      language: "en-US",
      text: "Hello, welcome to the service center by heedify",
      audioFileUrl:
        "https://callcenterconf.blob.core.windows.net/heedifymedia/defaultGreeting/Default_Greeting.wav",
    },
    flashMessage: {
      enabled: false,
      type: "text2speech",
      language: "en-US",
      text: "",
      audioFileUrl:
        "https://callcenterconf.blob.core.windows.net/heedifymedia/defaultGreeting/Default_Greeting.wav",
    },
    customMessage: {
      enabled: false,
      type: "text2speech",
      language: "en-US",
      text: "",
      audioFileUrl:
        "https://callcenterconf.blob.core.windows.net/heedifymedia/defaultGreeting/Default_Greeting.wav",
    },
  },

  deskOpen: {
    holidays: {
      audio: {
        type: "text2speech",
        language: "en-US",
        text: "We are in holidays",
        audioFileUrl:
          "https://callcenterconf.blob.core.windows.net/heedifymedia/Holidays/We_Are_On_Holidays.wav",
      },
      daysOff: [],
      weekendDays: [6, 0],
      holidaysAction: {
        type: "disconnect",
        targetType: "",
        targetId: "",
        queueId: "",
        queueDisplayName: "",
      },
    },
    openHours: {
      0: [{ start: "00:00", end: "23:59" }, { start: "08:30", end: "11:00" }],
      1: [{ start: "00:00", end: "23:59" }, { start: "08:30", end: "11:00" }],
      2: [{ start: "00:00", end: "23:59" }, { start: "08:30", end: "11:00" }],
      3: [{ start: "00:00", end: "23:59" }, { start: "08:30", end: "11:00" }],
      4: [{ start: "00:00", end: "23:59" }, { start: "08:30", end: "11:00" }],
      5: [{ start: "00:00", end: "23:59" }, { start: "08:30", end: "11:00" }],
      6: [{ start: "00:00", end: "23:59" }, { start: "08:30", end: "11:00" }],
      audio: {
        type: "text2speech",
        language: "en-US",
        text: "Out of Business Hours",
        audioFileUrl:
          "https://callcenterconf.blob.core.windows.net/heedifymedia/businessHours/Out_Of_Business_Hours.wav",
      },
      openHoursAction: {
        type: "disconnect",
        targetType: "",
        targetId: "",
        queueId: "",
        queueDisplayName: "",
      },
    },
  },

  routing: {
    0: {
      enabled: true,
      displayName: "",
      type: "",
      queueDisplayName: "",
      queueId: "",
      expectedDigitNumber: 1,
      lastTone: "",
      timeout: 10,
      audio: {
        type: "text2speech",
        language: "en-US",
        text: "",
        audioFileUrl:
          "https://clientsorage.blob.core.windows.net/tenants/de5e3c28-141c-4d3e-90ea-aa3326abe67d/b0cedab0-1a02-40b4-8ea4-181571affa51/welcome/Ring05.wav",
      },
      options: {},
      next: { type: "" },
    },
  },

  survey: {
    enabled: false,
    questions: {},
    timeout: 0,
    goodByeMessage: { type: "text2speech", language: "en-US", text: "" },
  },

  feedback: {},
  callRecordingReadersDetails: {},
  callRecordingEnabled: false,
  callRecordingReaders: [],
  workflows: [],

  permissions: {
    resourceAccount: {
      canCreate: true,
      canRead: true,
      canUpdate: true,
      canDelete: true,
    },
    greeting: {
      canCreate: true,
      canRead: true,
      canUpdate: true,
      canDelete: true,
      messages: {
        canCreate: true,
        canRead: true,
        canUpdate: true,
        canDelete: true,
      }
    },
    holidays: {
      canCreate: true,
      canRead: true,
      canUpdate: true,
      canDelete: true,
      openHour: {
        canCreate: true,
        canRead: true,
        canUpdate: true,
        canDelete: true,
      },
      holidayActions: {
        canCreate: true,
        canRead: true,
        canUpdate: true,
        canDelete: true,
      }
    },
    routing: {
      canCreate: true,
      canRead: true,
      canUpdate: true,
      canDelete: true,
    },
    recording: {
      canCreate: true,
      canRead: true,
      canUpdate: true,
      canDelete: true,
    },
    survey: {
      canCreate: true,
      canRead: true,
      canUpdate: true,
      canDelete: true,
    },
    reports: {
      canCreate: true,
      canRead: true,
      canUpdate: true,
      canDelete: true,
    },
    workflow: {
      canCreate: true,
      canRead: true,
      canUpdate: true,
      canDelete: true,
    },
  },
};
